import { Route, Routes } from 'react-router-dom'
import AcademicYearProviderPage from './Page'
import AcademicYearPage from './MarkingPeriodProvider/Page'
import { useSelector } from 'react-redux'

export default function AcademicYear() {
    const { permissions } = useSelector(state => state.session)
  
  return (
    <Routes>
      <Route path="/" element={<AcademicYearProviderPage permissions={permissions} />}>
        <Route path="/:academicYearId/*" element={<AcademicYearProviderPage />} />
        <Route path="/:academicYearId/:edit" element={<AcademicYearPage />} />
        <Route path="/:academicYearId/full-year/:markingPeriodId" element={<AcademicYearPage />} />
        <Route path="/:academicYearId/summer/:markingPeriodId" element={<AcademicYearPage />} />
      </Route>
    </Routes>
  )
}
